import React from 'react';
import pt from 'prop-types';
import Icon from 'components/icon';
import cx from 'classnames';

import './sidebar.scss';

export default class StorefrontEditorPage extends React.PureComponent {
  static propTypes = {
    page: pt.object.isRequired,
    selectedPage: pt.object,
    onClickPage: pt.func,
    onClickPageGroup: pt.func,
  };

  onClickPage = () => {
    const { page, onClickPage } = this.props;

    onClickPage?.(page.id);
  };

  onClickPageGroup = () => {
    const { page, onClickPageGroup } = this.props;

    onClickPageGroup?.(page.id);
  };

  render() {
    const { page, selectedPage } = this.props;
    const { id, url, label, items } = page;
    const hasUrl = Boolean(url);
    const hasNestedPages = Boolean(items);
    const disabled = !hasUrl && !hasNestedPages;

    return (
      <button
        className={cx('storefront-editor--page', {
          active: selectedPage?.id === id,
        })}
        type="button"
        onClick={hasNestedPages ? this.onClickPageGroup : this.onClickPage}
        disabled={disabled}
      >
        {label}
        {hasNestedPages && <Icon fa="chevron-right" faSize="xs" />}
      </button>
    );
  }
}
